import { h } from '@/lib/dom';

export interface ButtonProps {
  label?: string;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'dashed';
  size?: 'sm' | 'md';
  type?: 'button' | 'submit' | 'reset';
  onClick?: (e: MouseEvent) => void;
  disabled?: boolean;
  ariaLabel?: string;
  icon?: string;
  children?: Node | string;
}

export function Button(props: ButtonProps): HTMLButtonElement {
  const classes = ['btn', `btn-${props.variant ?? 'primary'}`];
  if (props.size === 'sm') classes.push('btn-sm');
  const btn = h(
    'button',
    {
      class: classes.join(' '),
      type: props.type ?? 'button',
      disabled: props.disabled ?? false,
      aria: props.ariaLabel ? { label: props.ariaLabel } : undefined,
      on: {
        click: (e) => {
          if (!props.disabled) props.onClick?.(e);
        },
      },
    },
    props.children
      ? [props.icon ? h('span', { 'aria-hidden': 'true' }, props.icon) : null, props.children]
      : [
          props.icon ? h('span', { 'aria-hidden': 'true' }, props.icon) : null,
          props.label ?? '',
        ],
  );
  return btn;
}
